import Paragraph from "antd/es/typography/Paragraph"
import { useMemo } from "react"
import ChinaFlag from "../../../components/icons/flags/ChinaFlag"
import HongKongFlag from "../../../components/icons/flags/HongKongFlag"
import IndiaFlag from "../../../components/icons/flags/IndiaFlag"
import IndonesiaFlag from "../../../components/icons/flags/IndonesiaFlag"
import JapanFlag from "../../../components/icons/flags/JapanFlag"
import MalasiaFlag from "../../../components/icons/flags/MalasiaFlag"
import PhlippinesFlag from "../../../components/icons/flags/PhlippinesFlag"
import SingaporeFlag from "../../../components/icons/flags/SingaporeFlag"
import SKoreaFlag from "../../../components/icons/flags/SKoreaFlag"
import TaiwanFlag from "../../../components/icons/flags/TaiwanFlag"
import ThailandFlag from "../../../components/icons/flags/ThailandFlag"
import VietnamFlag from "../../../components/icons/flags/VietnamFlag"
import AustraliaFlag from "../../../components/icons/flags/AustraliaFlag"

interface Props {
    data: any
}
const MarketItem = (props: Props) => {
    const { data } = props

    const coverges = useMemo(() => {
        let list: string[] = [];
        if (data?.offline_retail) {
            list.push("Offline Retail")
        }
        if (data?.online) {
            list.push("Online")
        }
        if (data?.food_service) {
            list.push("Food Service / Out of Home")
        }
        return list
    }, [data]);


    const capabilities = useMemo(() => {
        let list: string[] = [];
        if (data?.regulatory_compliance) {
            list.push("Regulatory Compliance")
        }
        if (data?.importation_clearance) {
            list.push("Importation & Clearance")
        }

        if (data?.ambient_warehousing && data?.cold_and_frozen_warehousing) {
            list.push("Warehousing - Cold & Frozen, Ambient")
        } else if (data?.cold_and_frozen_warehousing) {
            list.push("Warehousing - Cold & Frozen")
        } else if (data?.ambient_warehousing) {
            list.push("Warehousing - Ambient")
        }

        if (data?.retail_distribution) {
            list.push("Distribution")
        }
        if (data?.sales) {
            list.push("Sales")
        }
        if (data?.marketing) {
            list.push("Marketing")
        }
        return list;
    }, [data]);

    const flagIcon = useMemo(() => {
        switch (data?.regions?.name) {
            case "China":
                return <ChinaFlag />
            case "Hong Kong":
                return <HongKongFlag />
            case "India":
                return <IndiaFlag />
            case "Indonesia":
                return <IndonesiaFlag />
            case "Japan":
                return <JapanFlag />
            case "Malaysia":
                return <MalasiaFlag />
            case "Philippines":
                return <PhlippinesFlag />
            case "Singapore":
                return <SingaporeFlag />
            case "South Korea":
                return <SKoreaFlag />
            case "Taiwan":
                return <TaiwanFlag />
            case "Thailand":
                return <ThailandFlag />
            case "Vietnam":
                return <VietnamFlag />
            case "Australia":
                return <AustraliaFlag/>
            case "Thailand":
                return <ThailandFlag />

            default:
                return <></>
        }
    }, [data])


    return (
        <div className="rounded-[8px] bg-white">
            <div className="px-[10px] py-[8px] border-b border-[#F2F4F7] flex items-center gap-x-[8px]">
                {flagIcon}
                <p className="m-0 text-[13px] font-[500]">{data?.regions?.name}</p>
            </div>
            <div className="pt-[10px] px-[10px]">
                <p className="mb-[6px] text-[12px] font-[500]">Key Channel Coverage</p>
                <Paragraph>
                    <ul className="!list-disc">
                        {coverges?.map((item: any, index: number) => (
                            <li key={index} className="text-[12px] text-[#475467]">{item}</li>
                        ))}
                    </ul>
                </Paragraph>
            </div>
            <div className="pb-[10px] px-[10px]">
                <p className="mb-[6px] text-[12px] font-[500]">Key Capabilities</p>
                <Paragraph className="!mb-0">
                    <ul className="!list-disc !mb-0">
                        {capabilities?.map((item: any, index: number) => (
                            <li key={index} className="text-[12px] text-[#475467]">{item}</li>
                        ))}
                    </ul>
                </Paragraph>
            </div>
        </div>
    )
}

export default MarketItem